/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IMembershipType {
  Free = 'free',
  Premium = 'premium',
  CoachPlus = 'coach-plus',
  PremiumNonEquipment = 'premium-non-equipment',
}
